import { localeMap } from "~utils/i18n/localeMap";

export enum Locale {
  En = "en",
  Ja = "ja",
}

export type LocaleCode = (typeof Locale)[keyof typeof Locale];

export function getLanguageCodeLocale(locale: string | undefined): Locale {
  const entry = localeMap[locale as keyof typeof localeMap];

  return entry ? (entry.languageCode as unknown as Locale) : Locale.En;
}

export function getValidLocale(str: string | undefined): Locale {
  if (Object.values(Locale).includes(str as Locale)) return str as Locale;

  return Locale.En;
}

export const LANGUAGE_MAP = {
  [Locale.En]: 1,
  [Locale.Ja]: 2,
};
